<template>
  <div>
    <v-alert
      :value="true"
      type="warning"
      class="text-sm-center"
      v-if="!hayServicios"
    >
      No tiene servicios seleccionados
    </v-alert>
    <div
      v-for="(h, inho) in servicios.hoteles"
      v-bind:key="inho + 'hotelpanel'"
    >
      <CarritoPanelHotel
        :data-cy="`panelHotel`"
        :data="{
          hotel: h,
          traslado: servicios.traslados.find(
            t => t.unico_hotel === h.unico_carrito
          )
        }"
        class="pb-2"
      >
      </CarritoPanelHotel>
    </div>
    <div v-for="(cupo, incun) in servicios.cupos" v-bind:key="incun + 'cupon'">
      <CarritoPanelCupo :data="cupo"> </CarritoPanelCupo>
    </div>
    <div
      v-for="(t, intt) in servicios.tickets"
      v-bind:key="intt + 'ticketpanel'"
    >
      <CarritoPanelPase :data="t"> </CarritoPanelPase>
    </div>
    <v-container fluid grid-list-lg class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card color="grey lighten-3">
            <v-card-title primary-title class="pa-2">
              <v-layout row wrap>
                <v-flex class="py-0">
                  <p class="mb-0 caption">
                    IMP. PAIS 30% LEY 27.541
                  </p>
                </v-flex>
                <v-flex class="py-0">
                  <p class="caption text-right">
                    {{ servicios.tarifas.moneda }} {{ servicios.tarifas.ipais }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-title primary-title class="pa-2">
              <v-layout row wrap>
                <v-flex class="py-0">
                  <p class="mb-0 caption">
                    PERCEPCION REG 4815
                  </p>
                </v-flex>
                <v-flex class="py-0">
                  <p class="caption text-right">
                    {{ servicios.tarifas.moneda }}
                    {{ servicios.tarifas.ipais2 }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-title primary-title class="pa-2">
              <v-layout row wrap>
                <v-flex class="py-0">
                  <p class="mb-0 caption">
                    REG 5272/2022
                  </p>
                </v-flex>
                <v-flex class="py-0">
                  <p class="caption text-right">
                    {{ servicios.tarifas.moneda }}
                    {{ servicios.tarifas.ipais3 }}
                  </p>
                </v-flex>
                <v-flex x12 class="py-0">
                  <p class="caption mb-0">
                    El impuesto País (LEY 27.541) y la Percepción 35% (RG 4815),
                    Aplica Exclusivamente para pagos en PESOS ARS al tipo de
                    cambio $/USD del día de la transacción. No aplica para pagos
                    por trasferencia bancaria en USD.
                  </p>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <b-card
      bg-variant="success"
      text-variant="white"
      class="my-2 py-1 px-2"
      no-body
    >
      <b-row>
        <b-col cols="12">
          <p class="mb-0 text-center">
            <small
              @click="tarifasCollapse = !tarifasCollapse"
              class="cur-pointer"
              aria-controls="tarifas"
              :aria-expanded="tarifasCollapse ? 'true' : 'false'"
            >
              Ver detalles
              <v-icon
                :name="tarifasCollapse ? 'angle-up' : 'angle-down'"
              ></v-icon>
            </small>
          </p>
          <b-collapse id="tarifas" class="mt-2" v-model="tarifasCollapse">
            <p class="mb-0">
              <small>
                Tarifa:
                <span class="float-right">
                  {{ servicios.tarifas.moneda }}
                  {{ servicios.tarifas.tarifa }}</span
                >
              </small>
            </p>
            <p class="mb-0">
              <small>
                IVA total del pasajero:
                <span class="float-right">
                  {{ servicios.tarifas.moneda }}
                  {{ servicios.tarifas.iva }}</span
                >
              </small>
            </p>
            <p class="mb-0">
              <small>
                Tasas:
                <span class="float-right">
                  {{ servicios.tarifas.moneda }}
                  {{ servicios.tarifas.tasas }}</span
                >
              </small>
            </p>
            <p class="mb-0">
              <small>
                Gasto administrativo:
                <span class="float-right">
                  {{ servicios.tarifas.moneda }}
                  {{ servicios.tarifas.gastoAdm }}</span
                >
              </small>
            </p>
            <p class="mb-0">
              <small>
                Gasto de reserva:
                <span class="float-right">
                  {{ servicios.tarifas.moneda }}
                  {{ servicios.tarifas.gastoRsv }}</span
                >
              </small>
            </p>
          </b-collapse>
          <p class="mb-0 font-weight-medium">
            Total:
            <span class="float-right">
              {{ servicios.tarifas.moneda }} {{ servicios.tarifas.total }}</span
            >
          </p>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ResumenItinerario from "@/components/cupos/ResumenItinerario.vue";
import { mapGetters } from "vuex";
import CarritoPanelHotel from "@/components/utiles/CarritoPanelHotel.vue";
import CarritoPanelPase from "@/components/utiles/CarritoPanelPase.vue";
import CarritoPanelCupo from "@/components/utiles/CarritoPanelCupo.vue";
export default {
  name: "Carrito",
  components: {
    ResumenItinerario,
    CarritoPanelHotel,
    CarritoPanelPase,
    CarritoPanelCupo
  },
  mounted() {},
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    }),
    hayServicios() {
      const hay = Object.keys(this.servicios).some(item => {
        if (item === "tarifas") {
          return false;
        }
        return this.servicios[item].length === 0 ? false : true;
      });
      return hay;
    }
  },
  methods: {},
  data() {
    return {
      tarifasCollapse: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-cart-hab {
  font-size: 13px;
}
.hover-hab-as:hover {
  background-color: #eceff1;
}
</style>
